// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}", ""]);
// Exports
module.exports = exports;
